import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NgbAccordion, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap/accordion/accordion';
import { Observable } from 'rxjs';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { filterEmaDotcmsPageLinks, onClickEmaDotcmsPageLinks } from '../../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-faq',
  templateUrl: './dot-cms-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsFaqComponent implements DotCmsContentTypeComponent, OnChanges, OnInit, AfterViewChecked {
  @Input() identifier: string;
  lastPanelId: string;
  panelId: string;
  contentlet$: Observable<CustomDotCmsContentlet>;

  constructor(private dotCmsFacade: DotCmsFacade, private renderer: Renderer2, private el: ElementRef) {}

  ngOnChanges(): void {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier);
  }
  ngOnInit() {
    onClickEmaDotcmsPageLinks(this.el, this.renderer);
    this.panelId = `panel-${this.identifier}`;
  }
  ngAfterViewChecked() {
    filterEmaDotcmsPageLinks(this.el, this.renderer);
  }

  panelShadow($event: NgbPanelChangeEvent, shadow: NgbAccordion) {
    const activePanelId = $event.panelId;
    const activePanelElem = document.getElementById(activePanelId);
    if (!shadow.isExpanded($event.panelId)) {
      activePanelElem.parentElement.classList.add('open');
    }
    if (this.lastPanelId) {
      const lastPanelElem = document.getElementById(this.lastPanelId);
      if (this.lastPanelId === $event.panelId && !$event.nextState)
        activePanelElem.parentElement.classList.remove('open');
      else if (this.lastPanelId !== $event.panelId && $event.nextState) {
        lastPanelElem.parentElement.classList.remove('open');
      }
    }

    this.lastPanelId = $event.panelId;
  }
}
